module.exports = __webpack_public_path__ + "static/media/propaganda.43722722.svg";